import { UseFormSetError } from 'react-hook-form';

export const checkPayment = (
  payment: string,
  setError: UseFormSetError<any>,
  toastErrors: string[]
) => {
  const errorMessage =
    'Сумма пополнения должна быть в диапазоне от 100,00 рублей до 999 999 999,99 рублей';
  if (Number(payment) < 100 || !payment) {
    setError('payment', {
      type: 'manual',
      message: errorMessage,
    });
    toastErrors.push(errorMessage);
  }
  return toastErrors;
};
